var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont"},[_c('Resume',{attrs:{"dataList":_vm.collectionList}}),(!_vm.total)?_c('el-empty',{staticStyle:{"padding":"60px 0 300px"},attrs:{"image-size":100}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }